import $ from "jquery";

const isLastOptionSelected = function (select) {
  return select.find("option:last-child").is(":selected");
};

const toggleOtherField = function () {
  const $this = $(this);
  const $other = $("#" + $this.attr("id") + "_other").closest(".form-group");

  if (isLastOptionSelected($this)) {
    $other.show();
  } else {
    $other.hide();
  }
};

const modalShown = function () {
  $("#free_demo_request_industry, #free_demo_request_job_profile").each(function (i, e) {
    toggleOtherField.call(e);
  });
};

$(document).on("turbolinks:load", function () {
  $("#requestDemoModal").on("shown.bs.modal", modalShown);
  $("#free_demo_request_industry, #free_demo_request_job_profile").on("change", toggleOtherField);
});
